import React, { ReactNode } from 'react'
import { useIntercomContext } from './Provider'

type Props = { children: ReactNode }

export const Wrapper: React.FC<Props> = ({ children }) => {
  const { isAuthorised } = useIntercomContext()

  if (!isAuthorised) {
    return <>{children}</>
  }

  return <>{children}</>
}
